import * as React from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import useOwnUser from '../../../../../../hooks/useOwnUser'
import { useUpdateVacationMutation } from '../../../../../../features/vacations/vacationsApiSlice'
import { ICancelationProps } from '../../../../../../pkg/UI'
import {
  Backdrop,
  DialogContainer,
  DialogContent,
  DialogHeader,
  DialogBody,
  ButtonGroup,
  CancelButton,
  ConfirmButton,
  WarningIcon,
} from './cancelElements'

const CancelDialog = ({ ...props }: ICancelationProps): JSX.Element => {
  const { t } = useTranslation()
  const user = useOwnUser()
  const [cancelRequest] = useUpdateVacationMutation()
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault()
    setIsSubmitting(true)

    const data = { ...props.request }
    data.status = 'cancelled'
    data.decision_maker_id = user.userUID as number
    data.decision_date = dayjs(new Date()).toISOString()

    cancelRequest(data)
      .then((res: any) => {
        console.log(res)
      })
      .then(() => props.refetch())
      .then(() => props.handleClose())
      .catch((error) => {
        console.error('Error cancelling vacation:', error)
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault()
    props.handleClose()
  }

  if (!props.isOpen) return <></>

  return (
    <Backdrop>
      <DialogContainer>
        <DialogContent>
          <DialogHeader>
            <h2>{t('CompanyHistory:Cancel.cancelVacation')}</h2>
          </DialogHeader>

          <DialogBody>
            <WarningIcon>!</WarningIcon>
            <p>
              {t('CompanyHistory:Cancel.confirmMessage') ||
                'Are you sure you want to cancel this vacation request?'}
            </p>
          </DialogBody>

          <ButtonGroup>
            <CancelButton
              onClick={handleClose}
              disabled={isSubmitting}
            >
              {t('CompanyHistory:Cancel.cancel')}
            </CancelButton>
            <ConfirmButton
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              {isSubmitting ?
                t('CompanyHistory:Common.processing') || 'Processing...'
              : t('CompanyHistory:Cancel.cancelVacation')}
            </ConfirmButton>
          </ButtonGroup>
        </DialogContent>
      </DialogContainer>
    </Backdrop>
  )
}

export default CancelDialog
